import { saveAs } from 'file-saver'
import { useDispatch } from 'react-redux'

//UI

import { NonFormUpload } from '@/components/Elements'
import { Button, Flex, Heading, HStack, Spacer } from '@chakra-ui/react'
import { toast } from 'react-toastify'

//Hook
import { hideLoadingOverlay, showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'

//Helper
import { createExcelBlob } from '@/utils/fileHelper'
import { useCallback } from 'react'
import useSystemVariable from '../../useSystemVariable'
import { SystemVariableType } from '../../constants'

const SystemVariableListHeader = ({ title, type, handleAdd }) => {
  //Hooks

  const dispatch = useDispatch()
  const { useFetchAllSystemVariables, useUploadSystemVariables } = useSystemVariable()

  const { data: allSystemVariablesResponse } = useFetchAllSystemVariables(type, {
    page: 1,
    pageSize: 0,
  }) // Page Size 0 means get all

  const uploadSystemVariables = useUploadSystemVariables(type)

  const handleUpload = async (file) => {
    if (!file) {
      toast.error('No File Uploaded')
      return
    }

    try {
      dispatch(showLoadingOverlay())
      await uploadSystemVariables.mutateAsync(file)
    } catch (error) {
      console.error(error)
    } finally {
      dispatch(hideLoadingOverlay())
    }
  }

  const handleDownloadAll = useCallback(() => {
    if (!allSystemVariablesResponse?.data) {
      return
    }
    try {
      let excelData = []
      if (allSystemVariablesResponse.data.length === 0) {
        excelData =
          type === SystemVariableType.HS_CODE
            ? [
                {
                  code: '',
                  name: '',
                  type: '',
                  descriptionZh: '',
                  description: '',
                  status: '',
                },
              ]
            : [
                {
                  code: '',
                  name: '',
                  type: '',
                  status: '',
                },
              ]
      } else {
        excelData = allSystemVariablesResponse.data.map((row) => {
          if (type === SystemVariableType.HS_CODE) {
            return {
              code: row.code,
              name: row.name,
              type: row.type,
              descriptionZh: row.descriptionZh,
              description: row.description,
              status: row.status,
            }
          }
          return {
            code: row.code,
            name: row.name,
            type: row.type,
            status: row.status,
          }
        })
      }

      const excelBlob = createExcelBlob(excelData)
      saveAs(excelBlob, `${title}.xlsx`)
    } catch (err) {
      console.log(err)
    }
  }, [allSystemVariablesResponse?.data, title])
  return (
    <>
      <Flex p={5} borderBottom="1px solid #d8dbe0">
        <Heading>{title}</Heading>
        <HStack mx="5">
          <Button colorScheme="gray" onClick={handleDownloadAll}>
            Download
          </Button>
          <NonFormUpload uploadHandler={handleUpload} />
        </HStack>
        <Spacer />
        <Button colorScheme="blue" onClick={handleAdd}>
          Add {title}
        </Button>
      </Flex>
    </>
  )
}

export default SystemVariableListHeader
